import React from 'react';

const ThemeContext = React.createContext({
  themeContext: '',
  nativeRouteName:'',
});

export default ThemeContext;
